import { LeoRPCResult, parseResponse } from "@surya-digital/leo-ts-types";
import { APIClient, Request, Method } from "@surya-digital/tedwig";
import { AssignSurveyRPC } from "./assignSurveyRPC";

export class AssignSurveyRPCClientImpl extends AssignSurveyRPC {
  readonly client: APIClient;

  constructor(client: APIClient) {
    super();
    this.client = client;
  }

  async execute(request: AssignSurveyRPC.Request): Promise<LeoRPCResult<AssignSurveyRPC.Response, AssignSurveyRPC.Errors.Errors>> {
    const requestBody = request.toDTO();
    const response = await this.client.sendRequest(
      new Request(
        Method.Post,
        "respondent/AssignSurvey",
        undefined,
        undefined,
        requestBody
      )
    );
    return parseResponse<
      AssignSurveyRPC.ResponseDTO,
      AssignSurveyRPC.Errors.ErrorsDTO,
      AssignSurveyRPC.Response,
      AssignSurveyRPC.Errors.Errors
    >(
      response,
      "respondent/AssignSurvey",
      AssignSurveyRPC.Response.fromDTO,
      AssignSurveyRPC.Errors.fromDTO
    );
  }
}
